export const install = (app, plugins) => {
  for (let i = 0; i < plugins.length; i++) {
    plugins[i](app);
  }

  return app;
};